<template>
	<vx-card class="editTicket card-ticket">
    <ConfirmMarginalityAction
      :active.sync="marginalityPopupState"
      class="marginality-popup"
      @confirm="createTask"
      @cancel="marginalityPopupState = false"
    />
		<CardTicketIntercom
			ref="CardTicketIntercom"
			:model="model"
			@updateModel="$emit('updateModel')"
		/>
        <vs-tabs
          :value="indexTab"
          class="edit-ticket-tabs"
          @setActiveTab="setActiveTab" @setButtonAction="setButtonAction"
        >
            <vs-tab :label="$t('informationAboutOrder')">
                <div>
                    <div class="vx-row mt-5">
                        <div class="vx-col pt-2 sm:w-1/3 font-bold">{{ $t('site') }}</div>
                        <div class="vx-col pt-2 sm:w-1/3">
                            {{ websiteName }}
                        </div>
                    </div>
                    <div class="vx-row mt-1">
                        <div class="vx-col pb-2 sm:w-1/3 font-bold">{{ $t('date') }}</div>
                        <div class="vx-col pb-2 sm:w-1/3">
                            {{ model.created }}
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('client') }}</div>
                        <div class="vx-col pt-2 pb-2 sm:w-1/3">
                            <RouterLink :to="`/${pathToClient}/${clientId}`">
                                {{ clientName }}
                            </RouterLink>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col pt-2 pb-2 w-full">
							<vs-checkbox
								v-model="model.skip_reminders"
								@input="updateTicket"
								class="w-full"
							>{{ $t('skipReminders') }}</vs-checkbox>
                        </div>
                    </div>
                    <div class="vx-row mt-5">
                        <div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('phone') }}</div>
                        <div class="vx-col pt-2 pb-2 sm:w-1/3">
                            {{ phone }}
                        </div>
                    </div>
                    <div class="vx-row mt-2 mb-3">
                        <div class="vx-col w-full">
                            <vs-input
                                v-validate="'required'"
                                v-model="model.name"
                                @input="updateTicket"
                                data-vv-validate-on="blur"
                                :label="$t('workName')"
                                type="text"
                                name="name"
                                class="w-full"
                            />
                            <span v-if="errors.first('name')" class="text-danger text-sm">
                                {{ $t('fieldFilledIncorrect') }}
                            </span>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full">
                            <div
                                class="vs-component vs-con-input-label vs-input vs-input-primary"
                            >
                                <label class="vs-input--label">{{ $t('subjectArea') }}</label>
                                <div class="vs-con-input"></div>
                                <v-select
                                    v-model="model.subject"
                                    :clearable="false"
                                    :reduce="subject => subject.id"
                                    :options="subjects"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    @input="updateTicket(true)"
                                    name="work"
                                    label="name"
                                    class="single-row-select"
                                    :disabled="readOnly"
                                />
                            </div>
                            <span v-if="errors.first('work')" class="text-danger text-sm">
                                {{ $t('fieldFilledIncorrect') }}
                            </span>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                            <div
                                class="vs-component vs-con-input-label vs-input vs-input-primary"
                            >
                                <label class="vs-input--label">{{ $t('workLanguage') }}</label>
                                <div class="vs-con-input"></div>
                                <v-select
                                    v-model="model.language"
                                    :clearable="false"
                                    :reduce="language => language.id"
                                    :options="languages"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    @input="updateTicket(true)"
                                    name="language"
                                    label="name"
                                    class="single-row-select"
                                />
                            </div>
                            <span v-if="errors.first('language')" class="text-danger text-sm">
                                {{ $t('fieldFilledIncorrect') }}
                            </span>
                        </div>
                    </div>
                    <div class="vx-row mb-10">
                        <div class="vx-col sm:w-1/2 w-full">
                            <div
                                class="vs-component vs-con-input-label vs-input vs-input-primary"
                            >
                                <label class="vs-input--label">{{ $t('qualityLevel') }}</label>
                                <div class="vs-con-input"></div>
                                <v-select
                                    :disabled="readOnly"
                                    v-model="model.quality_level"
                                    :clearable="false"
                                    :reduce="(level) => level.id"
                                    :options="levels"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    @input="updateTicket(true)"
                                    name="level"
                                    label="name"
                                    class="single-row-select"
                                />
                            </div>
                            <span v-if="errors.first('level')" class="text-danger text-sm">
                                {{ $t('fieldFilledIncorrect') }}
                            </span>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full">
                            <vx-input-group>
                                <div
                                    class="vs-component vs-con-input-label vs-input vs-input-primary"
                                >
                                    <label class="vs-input--label">{{ $t('dueDate') }}</label>
                                    <div class="vs-con-input"></div>
                                    <vs-datepicker
                                        v-model="model.due_date"
                                        :clearable="false"
                                        @change="updateTicket(true)"
                                        format="dd.MM.yyyy"
                                        name="date"
                                    ></vs-datepicker>
                                </div>
                                <span v-if="errors.first('date')" class="text-danger text-sm">
                                    {{ $t('fieldFilledIncorrect') }}
                                </span>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-5">
                        <div class="vx-col vx-row w-full">
                            <!-- <vs-radio
                                v-for="(item, index) in payTypes"
                                v-model="model.pay_type"
                                v-validate="'required'"
                                :key="index"
                                :vs-value="item.status"
                                @change="updateTicket"
                                vs-name="payType"
                                class="vx-col"
                                name="paymentMethod"
                            >{{ item.label }}</vs-radio> -->
                            <vs-radio
                                v-for="(item, index) in filterPayTypes"
                                v-model="model.pay_type"
                                v-validate="'required'"
                                :key="index"
                                :vs-value="item.status"
                                @change="updateTicket(false)"
                                vs-name="payType"
                                class="vx-col"
                                name="paymentMethod"
                            >{{ item.label }}</vs-radio>
                        </div>
                        <span v-if="errors.first('paymentMethod')" class="text-danger text-sm vx-col">
                            {{ $t('fieldFilledIncorrect') }}
                        </span>
                    </div>
                    <div class="vx-row mb-8">
                        <div class="vx-col w-full">
                            <div
                                class="vs-component vs-con-input-label vs-input vs-input-primary"
                            >
                                <label class="vs-input--label">{{ $t('clientsComment') }}</label>
                                <div class="vs-con-input"></div>
        <!--						<VueEditor-->
        <!--							v-model="model.description"-->
        <!--							class="card-ticket__about mb-0"-->
        <!--							v-validate="'min:3'"-->
        <!--							name="about"-->
        <!--							@input="updateTicket"-->
        <!--						/>-->
        <!--						<vs-textarea-->
        <!--							v-model="model.description"-->
        <!--							v-validate="'min:3'"-->
        <!--							@input="updateTicket"-->
        <!--							name="about"-->
        <!--							class="card-ticket__about mb-0"-->
        <!--						/>-->
                                <CKEditor
                                    v-model="model.description"
                                    v-validate="'min:3'"
                                    @input="updateTicket(false)"
                                    name="about"
                                    class="card-ticket__about"
                                />
                            </div>
                            <span v-if="errors.first('about')" class="text-danger text-sm">
                                {{ $t('fieldFilledIncorrect') }}
                            </span>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <div v-if="model.files && model.files.length > 0" class="vx-row mb-3">
                                <div
                                    v-for="(file, index) in model.files"
                                    :key="index"
                                    class="vx-col mb-3 file-container"
                                >
                                    <a
                                        @click="(e) => openImagePopup(e, file)"
                                        target="_blank"
                                        class="fileName"
                                        :href="file.fullUrl || file.url"
                                    >
                                        <span class="fileName__icon">
                                            <svg width="13.75" height="15" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;"><defs></defs><rect x="0" y="0" width="13.75" height="15" fill="transparent" class="stencil__selection-helper"></rect><path d="M13.75 12.302061576860293C13.75 13.069410005180824 13.493333333333332 13.709681623715792 12.979999999999999 14.222876432465196 12.466666666666663 14.736071241214592 11.823777777777776 14.995112430392865 11.051333333333332 15 10.166444444444442 15 9.396444444444443 14.67253283632181 8.741333333333333 14.017598508965431 8.741333333333333 14.017598508965431 1.1146666666666667 6.400321276242176 1.1146666666666667 6.400321276242176 0.3715555555555555 5.647635556743054 0 4.760541673047661 0 3.7390396251559954 0 2.697987298835781 0.36177777777777775 1.8133371999439558 1.0853333333333333 1.0850893284805196 1.8088888888888888 0.3568414570170835 2.6888888888888887-0.004838693911065839 3.725333333333333 0.000048875696071259966 4.761777777777777 0.000048875696071259966 5.6564444444444435 0.36906038103492667 6.409333333333332 1.1070833917126368 6.409333333333332 1.1070833917126368 12.349333333333332 7.0601431732056925 12.349333333333332 7.0601431732056925 12.412888888888888 7.123681578098473 12.444666666666665 7.194551337401962 12.444666666666665 7.272752451116157 12.444666666666665 7.3802789824731745 12.344444444444443 7.531793640294427 12.143999999999998 7.727296424579914 11.943555555555553 7.9227992088654 11.791999999999998 8.02299438581171 11.689333333333332 8.027881955418849 11.606222222222222 8.027881955418849 11.530444444444443 7.996112752972457 11.461999999999998 7.932574348079673 11.461999999999998 7.932574348079673 5.514666666666666 1.9721832121759135 5.514666666666666 1.9721832121759135 4.996444444444443 1.4687635426407866 4.402444444444443 1.2170537078732226 3.7326666666666664 1.217053707873223 3.0384444444444445 1.2170537078732226 2.454222222222222 1.4614321882300807 1.98 1.950189148943796 1.5057777777777774 2.438946109657511 1.266222222222222 3.032785816924676 1.2613333333333332 3.7317082707452895 1.2613333333333332 4.4159680157444905 1.5106666666666666 5.007363938208085 2.009333333333333 5.505896038136076 2.009333333333333 5.505896038136076 9.628666666666666 13.137835979680744 9.628666666666666 13.137835979680744 10.039333333333332 13.548391826680266 10.513555555555554 13.753669750180027 11.051333333333332 13.753669750180027 11.471777777777776 13.753669750180027 11.818888888888885 13.616817801180186 12.092666666666664 13.343113903180505 12.366444444444442 13.06941000518082 12.50333333333333 12.722392563074084 12.503333333333334 12.302061576860293 12.503333333333334 11.764428920075204 12.297999999999998 11.290334668182897 11.887333333333332 10.879778821183379 11.887333333333332 10.879778821183379 6.1819999999999995 5.1759850896543185 6.1819999999999995 5.1759850896543185 6.010888888888887 5.014695292618792 5.812888888888888 4.934050394101029 5.587999999999999 4.934050394101029 5.402222222222221 4.934050394101029 5.245777777777777 4.997588798993812 5.118666666666666 5.124665608779378 4.991555555555555 5.251742418564945 4.9304444444444435 5.4081446459933336 4.9353333333333325 5.593872291064546 4.9353333333333325 5.804037784171443 5.015999999999999 5.99709678365336 5.1773333333333325 6.173049289510298 5.1773333333333325 6.173049289510298 9.203333333333331 10.197962860987744 9.203333333333331 10.197962860987744 9.271777777777775 10.266388835487664 9.305999999999997 10.339702379594723 9.306 10.417903493308916 9.305999999999997 10.520542455058795 9.203333333333331 10.674500897683618 8.998 10.879778821183379 8.792666666666666 11.085056744683136 8.638666666666666 11.185251921629447 8.535999999999998 11.180364352022313 8.457777777777777 11.180364352022313 8.386888888888887 11.148595149575922 8.323333333333332 11.08505674468314 8.323333333333332 11.08505674468314 4.297333333333333 7.0601431732056925 4.297333333333333 7.0601431732056925 3.8817777777777773 6.659362465420444 3.6739999999999995 6.170605504706729 3.6739999999999995 5.593872291064546 3.6739999999999995 5.056239634279458 3.862222222222222 4.601695660815703 4.238666666666666 4.230240370673279 4.61511111111111 3.858785080530855 5.0697777777777775 3.6730574354596426 5.602666666666666 3.6730574354596435 6.179555555555555 3.6730574354596426 6.665999999999999 3.8783353589594034 7.0619999999999985 4.288891205958925 7.0619999999999985 4.288891205958925 12.767333333333333 9.992684937487986 12.767333333333333 9.992684937487986 13.422444444444443 10.632956556022954 13.75 11.402748769147056 13.75 12.302061576860293 13.75 12.302061576860293 13.75 12.302061576860293 13.75 12.302061576860293" stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(255, 255, 255)" fill-rule="evenOdd"></path></svg>
                                        </span>

                                        <p class="fileName__text">
                                            {{ getFileName(file) }}
                                        </p>

                                        <feather-icon
                                            icon="XIcon"
                                            class="fileName__close text-danger ml-2 cursor-pointer"
                                            @click.stop.prevent="confirmFileDeletion(file)"
                                        />
                                    </a>
                                </div>
                            </div>
                            <vs-upload
                                v-model="files"
                                :key="'filesToUpload' + filesToUploadCounter"
                                :show-upload-button="false"
                                accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.odt,.rtf,.pdf,.txt,.csv,.zip,.page,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r"
                                :text="$t('loadFile')"
                                class="w-full"
                                @change="addPhoto"
                                @on-delete="deletePhoto"
                            />
                        </div>
                        <div class="vx-col mt-3">
                            <span
                                v-if="filesToUpload.length !== 0"
                                class="status status-ok cursor-pointer"
                                @click="uploadPhotos"
                            >{{ $t('confirmUploading') }}</span>
                        </div>
                    </div>
                    <div
                        v-for="(item, index) in model.work_types"
                        :key="index" class="works-list"
                    >
                        <div class="vx-row works-list__container">
                            <div class="vx-row vx-col works-list__row">
                                <div class="vx-col w-1/2 works-list__types">
                                    <div
                                        class="vs-component vs-con-input-label vs-input vs-input-primary"
                                    >
                                        <label class="vs-input--label">{{ $t('workType') }}</label>
                                        <v-select
                                            :disabled="readOnly"
                                            v-model="item.work_type_id"
                                            v-validate="'required'"
                                            :clearable="false"
                                            :reduce="work => work.id"
                                            :options="works"
                                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                            @input="handleChangedWork(item.work_type_id, index)"
                                            name="work"
                                            label="name"
                                            class="single-row-select"
                                        />
                                    </div>
                                    <span class="text-danger text-sm">
            <!--						{{ errors.first("level") }}-->
                                </span>
                                </div>
                                <div class="vx-col w-1/2">
                                    <vs-input
                                        :disabled="readOnly"
                                        v-validate="'required|numeric'"
                                        v-model="item.pages_number"
                                        @input="handleChangePages(item)"
                                        data-vv-validate-on="blur"
                                        :label="$t('pagesAmountShort')"
                                        type="number"
                                        name="pages"
                                        class="w-full"
                                    />
                                    <span class="text-danger text-sm">
            <!--						{{ errors.first("name") }}-->
                                </span>
                                </div>
                            </div>
                            <div class="vx-row vx-col works-list__row">
                                <div class="vx-col w-1/2 recommended">
                                    <div class="vx-row">
                                        <div class="vx-col recommended__title">{{ $t('recommendedSumShort') }}</div>
                                    </div>
                                    <div class="vx-row recommended__price">
                                        <div class="vx-col">{{ Math.round(item.recommended_price) || 0 }} €</div>
                                    </div>
                                </div>
                                <div v-if="index !== 0" class="vx-col w-1/2 flex items-end works-list__delete">
                                    <vs-custom-button
                                        type="border"
                                        color="danger"
                                        @click="removeWorkType(index)"
                                    >{{ $t('delete') }}</vs-custom-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="works-add">
                                <vs-custom-button :disabled="readOnly" @click="addWorkType">{{ $t('add') }}</vs-custom-button>
                            </div>
                        </div>
                    </div>
					<div v-if="model.additional_attributes && model.additional_attributes.order_details" class="vx-row">
						<div class="vx-col w-full">
							<div class="works-add">
								<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('details') }}</div>
								<div class="vx-col pt-2 pb-2 sm:w-1/3">
									{{ model.additional_attributes.order_details }}
								</div>
							</div>
						</div>
					</div>
					<div v-if="model.additional_attributes && model.additional_attributes.client_file" class="vx-row">
						<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t("client_file") }}</div>
						<div class="vx-col pt-2 pb-2">
							<a target="_blank" :href="model.additional_attributes.client_file.file">{{ model.additional_attributes.client_file.file }}</a>
						</div>
					</div>
					<CardTicketUtm v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1 && (model.utm || model.source)" :utm="model.utm" :source="model.source"/>
                </div>
            </vs-tab>
            <vs-tab :label="commentsTabLabel" class="px-0">
                <VuePerfectScrollbar :settings="settings" class="pr-4">
                    <div v-if="commentsList" class="comments-list">
                        <ul v-for="(item, index) in commentsList" :key="index">
                            <li class="d-flex column list-item pb-1 mb-4">
                                <p>{{item.content}}</p>
                                <div class="d-flex mt-2 justify-between">
                                    <p>{{ item.author.firstName + ' ' + item.author.lastName }}</p>
                                    <p>{{item.created}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </VuePerfectScrollbar>
                <div class="mt-3">
					<vs-textarea
                        v-model="commentText"
                        :label="$t('comment')"
                        rows="4"
                    />
                </div>
                <div class="set-ticket-failed__controls">
                    <vs-button
                        class="mr-1"
                        color="primary"
                        :disabled="!commentText || disableCommentButton"
                        @click="sendComment"
                    >{{ $t('send') }}</vs-button>
                </div>
            </vs-tab>
            <vs-tab v-if="showViewButton" :label="$t('view')" class="px-0" isButton></vs-tab>
        </vs-tabs>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import { VueEditor } from "vue2-editor";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import moment from "moment";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ConfirmMarginalityAction from "@/components/dialogs/ConfirmMarginalityAction.vue";

import CardTicketUtm from "@/views/Tickets/CardTicketUtm.vue";
import CardTicketIntercom from "@/views/Tickets/CardTicketIntercom.vue";
import order from "../Orders/Order.vue";

export default {
	name: "CardTicketEdit",
	mixins: [databaseManager, notifier],
	components: {
		vSelect,
		VueEditor,
    	VuePerfectScrollbar,
		ConfirmMarginalityAction,
		CardTicketUtm,
		CardTicketIntercom,
	},
	props: {
		model: 		{ default: null },
		subjects: 	{ default: [] },
		languages: 	{ default: [] },
		levels: 	{ default: [] },
		payTypes: 	{ default: [] },
		works: 		{ default: [] },
    isEditView: { default: false },
    isMarginalityLow: { default: false },
    inputHasChanged: { default: false },
	},
	data() {
		return {
			updateTimeout: null,
			files: [],
			filesToUpload: [],
			filesToUploadCounter: 0,
            commentText: '',
            indexTab: 0,
            disableCommentButton: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 1,
				swipeEasing: true,
			},

      marginalityPopupState: false,
		}
	},
	computed: {
		order() {
			return order
		},
        readOnly() {
            if(this.model.status === 'new'
				|| this.model.status === 'client_not_answer'
				|| this.model.status === 'offer_sent'
				|| this.model.status === 'processing') return false
            return true
        },
        showViewButton() {
            if(this.model.status === 'new'
                || this.model.status === 'client_not_answer'
                || this.model.status === 'offer_sent'
                || this.model.status === 'processing') return false
            return true
        },
        canShowCommentsTab() {
            const role = this.$store.state.auth.role
            return role === 'manager' || role === 'admin'
        },
        commentsTabLabel() {
            const commentsTitle = this.$t('comments')
            if (this.model && this.model.comments) {
                const count = this.model.comments
                if (count.length) {
                    return `${commentsTitle} (${count.length})`
                }
                return commentsTitle
            }
            return commentsTitle
        },
        commentsList() {
            return this.model ? this.model.comments : null
        },
		phone() {
            const model = this.model
            if (model && model.client && model.client.phone) return this.model.client.phone
            return '---'
		},
		filterPayTypes() {
			return this.payTypes.filter(el => el.status === 2)
		},
		minDate() {
			return new Date();
		},
		websiteName() {
			return this.model.website || "---";
		},
		clientId() {
			if(!this.model.client) return "---";
			return this.model.client.id;
		},
		clientName() {
			if(!this.model.client) return "---";
			return this.model.client.full_name !== ""
				? this.model.client.full_name : "---";
		},
		pathToClient() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return "client";
			} else if(role === "manager") {
				return "clientM";
			}
		},
	},

    watch: {
        indexTab(newVal) {
            if (newVal) {
                this.commentText = ''
            }
        }
    },

	methods: {
        async createTask() {
          try {
            await this.dbCreateMarginalityTask(this.model.id)

            this.setButtonAction()
            this.marginalityPopupState = false
          } catch (e) {
            console.error(e);
          }
        },

        checkMarginalityState() {
            if (this.isMarginalityLow && this.inputHasChanged) {
              this.marginalityPopupState = true
            } else {
              this.setButtonAction()
            }
        },

        setButtonAction() {
            this.$emit('update:isEditView', false)
        },
        setActiveTab(data) {
            this.indexTab = data
        },
        async sendComment() {
            this.disableCommentButton = true
            try {
                await this.dbSendComment(this.model.id, this.commentText);
                this.disableCommentButton = false
                this.notifySuccess(this.$t('addedSuccessfully'));
                this.commentText = ''
                this.$emit('updateModel')
            } catch (e) {
                this.notifyError(e.message);
                this.disableCommentButton = false
            }
        },
		openImagePopup(e, file) {
			this.$emit('openImagePopup', e, file)
		},
		async validateOrder() {
			return await this.$validator.validateAll();
		},
		getFileName(file) {
			const path = file.url.split("/");
			let filePath = path[path.length - 1]
			// if (filePath.length > 40) return filePath.substr(0, 40) + '...'
			return filePath
		},
		async updateTicket(recalcPrices = false) {
			await this.updateTicketAsync();
      setTimeout(() => {
        this.$emit('recalcPrices', recalcPrices)
      }, 1000);
		},
		updateWorkTypes(workTypes) {
			for(let work of workTypes) {
				const match = this.model.work_types.find(item => item.work_type_id === work.work_type_id);

				if(match === undefined) return;

				work.recommended_price = match.recommended_price;
			}

			this.model.work_types = workTypes;
		},
		async updateTicketAsync(isImmediate = false){
			if(await this.$validator.validateAll() !== true) return;

			if(!isImmediate) {
				if(this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				}

				this.updateTimeout = setTimeout(() => {
					this.updateTicketAsync(true);
					this.updateTimeout = null;
				}, 700);

				return;
			}

			try {
				if(await this.$validator.validateAll() !== true) return;

        const date = this.model.due_date ? moment(this.model.due_date).format("YYYY-MM-DD") : null

				const workTypes = this.model.work_types;

				const data = {
					name: this.model.name,
					subject: this.model.subject,
					work_types: workTypes.map(item => ({
						work_type: item.work_type_id,
						pages_number: item.pages_number,
					})),
					quality_level: this.model.quality_level,
					pages_number: this.model.pages_number,
					language: this.model.language,
					pay_type: this.model.pay_type,
					due_date: date,
					description: this.model.description,
					skip_reminders: this.model.skip_reminders ? 1 : 0,
					files: this.model.files.map(item => item.url)
				};

				const updated = await this.dbUpdateOrder(this.model.id, data);
				await this.$emit("updateTicket", updated);

				this.updateWorkTypes(workTypes);

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async handleChangedWork(type, index) {
			const matches = this.model.work_types.filter(work => work.work_type_id === type);

			if(matches.length > 1) {
				this.model.work_types.splice(index, 1);
			}

			await this.updateTicket(true);
			setTimeout(() => this.$emit("updatedWorkType", type), 200);
		},
		async handleChangePages(stage) {
			stage.pages_number = (+stage.pages_number).toString();

			if(stage.work_type_id !== 0) {
				await this.updateTicket(true);
			}
		},
		addPhoto(path, files) {
			this.filesToUpload.push(files[files.length - 1]);
		},
		deletePhoto(file) {
			const index = this.filesToUpload.findIndex(item => item === file);
			if(index !== -1) {
				this.filesToUpload.splice(index, 1);
			}
		},
		async uploadPhotos() {
			let urls = await this.dbUploadMany(this.filesToUpload);
			urls.forEach(item => this.model.files.push(item));
			this.filesToUpload = [];
			this.filesToUploadCounter++;

			await this.updateTicket();
		},
		confirmFileDeletion(file) {
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: this.$t('confirmDeletion'),
				text: this.$t('doYouWantToDeleteFile'),
				accept: () => this.deleteUploadedPhoto(file),
				acceptText: this.$t('confirm'),
				cancelText: this.$t('cancel')
			});
		},
		async deleteUploadedPhoto(file) {
			try {
				const start = file.url.indexOf('/upload');
				const filePath = file.url.substr(start);

				await this.dbDeleteOne(this.model.id, filePath);
				await this.updateTicket();

				this.notifySuccess(this.$t('fileDeletedSuccessfully'));
			} catch {
				this.notifyError(this.$t('fileDeletionError'));
			}
		},
		async addWorkType() {
			this.model.work_types.push({
				work_type_id: 0,
				pages_number: 0,
				recommended_price: 0
			});
		},
		async removeWorkType(index) {
			this.model.work_types.splice(index, 1);
			await this.updateTicket();

			let type = null;

			if(this.model.work_types.length !== 0) {
				type = this.model.work_types[0].work_type_id;
			}

			setTimeout(() => this.$emit("updatedWorkType", type), 200);
		},
	},
}
</script>

<style lang="scss">
.card-ticket {
    .con-vs-tabs .con-slot-tabs {
        overflow: visible !important;
    }
    .file-container {
        @media screen and (max-width: 600px) {
            width: 100%;
        }
        .fileName {
            @media screen and (max-width: 600px) {
                width: 100%;
            }
            padding-right: 0;
            &__text {
                max-width: 300px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                @media screen and (max-width: 600px) {
                    max-width: 100%;
                }
            }
            &__close {
                background: none !important;
            }
        }
    }

	&__about {
		display: flex;
		flex-direction: column;
		min-height: 280px;

		textarea {
			flex: 1 0 auto;
			//height: 100%;
		}

		.vs-textarea:focus {
			resize: none !important;
		}
	}

	.works-list {
		border-top: 1px solid #e4e4e4;
		padding-top: 25px;
		margin-top: 25px;

		&__row {
			flex: 100px 1 1;
		}

		.vs-button {
			width: 100%;
			padding-left: 0 !important;
			padding-right: 0 !important;
		}

		.recommended {
			padding-top: 0.1rem;
			&__title {
				font-size: .85rem;
			}

			&__price {
				padding-top: .80rem;
			}
		}

		@media
		screen and (max-width: 1460px) and (min-width: 992px),
		screen and (max-width: 540px){

			&__container {
				flex-direction: row;
			}

			&__row {
				&:first-child {
					flex: 60%;
					flex-direction: column;
				}

				&:last-child {
					flex: 40%;
					flex-direction: column-reverse;
				}

				.vx-col {
					width: 100% !important;
					flex-basis: 1px;
					flex-grow: 1;
					flex-shrink: 1;
				}
			}
		}

		&__types, &__delete {
			margin-bottom: 10px;
		}
	}

	.works-add {
		border-top: 1px solid #e4e4e4;
		padding-top: 25px;
		margin-top: 25px;
	}

  .ps {
      max-height: 450px;
  }

  .comments-list {
      overflow-y: auto;
      scrollbar-width: thin;

      .list-item {
          border-bottom: 1px solid #cfcfcf;
      }
  }

}
.intercom-card {
	align-items: center;
	.vs-button {
		padding: 0 0.8rem !important;
		font-size: .9em !important;
		height: 30px;
	}
	.intercom-id {
		line-height: 38px;
		font-size: 0.8em;
		margin-top: -25px;
	}
}
</style>
